export default __webpack_public_path__ + "static/media/favicon.5ae87763.png";